<span class="site-info-directives">
  <i class="fa" [ngClass]="icon"></i> {{status}}
</span>
